module.exports = "/packs/images/svg/arrow_white~ce821d82d5b62cb33e5d5703e41c76ac.svg";